import { createFileRoute } from "@tanstack/react-router";
import { GlobalShell } from "~/components/GlobalShell";
import { ForgotPasswordForm } from "~/app/(new)/(global)/forgot-password/ForgotPasswordForm";

export const Route = createFileRoute("/forgot-password")({
  component: ForgotPasswordPage,
});

function ForgotPasswordPage() {
  return (
    <GlobalShell>
      <ForgotPasswordForm />
    </GlobalShell>
  );
}
